import { Tag } from "antd";

function VoidSubmittalTag() {
  return (
    <Tag className="text-black text-opacity-50 bg-ciq-gray-200 font-bold text-xs border-none px-2 py-1 rounded flex items-center justify-center w-full">
      Void
    </Tag>
  );
}

export default VoidSubmittalTag;
